import moment from 'moment';

let options = [
	{
		name: 'Link',
		description: 'Turns a highlight into a simple HTML link',
		category: 'General purpose',
		fx: function(note) {
			return `<a href="${note.ref}">${note.text}</a>`;
		}
	},
	{
		name: 'Link with note',
		description:
			'Link with your note as the link text. If no note is added, it will fallback to a normal link',
		category: 'General purpose',
		fx: function(note) {
			let text = note.text;
			if (note.comment && note.comment.raw) {
				text = note.comment.raw;
			}
			return `<a href="${note.ref}">${text}</a>`;
		}
	},
	{
		name: 'JSON',
		description:
			'Link with your note as the link text. If no note is added, it will fallback to a normal link',
		category: 'General purpose',
		fx: function(note) {
			return JSON.stringify(note);
		}
	},
	{
		name: 'Quote',
		description:
			'Turns a highlight into a quote. Works best if a comment is added',
		category: 'General purpose',
		fx: function(note) {
			let text = note.text;
			if (note.type === 'bookmark') {
				if (note.meta && note.meta.title) {
					text = note.meta.title;
				}
			}
			let comment = '';
			if (note.comment && note.comment.raw) {
				comment = note.comment.raw;
			}
			return `"${text}" - ${comment}`;
		}
	},
	{
		name: 'APA - Biblography style',
		description:
			'APA style annotation. Good for pasting as a reference in a research paper.',
		category: 'Citation styles',
		fx: function(note) {
			let title = '';
			if (note.meta && note.meta.title) {
				title = note.meta.title;
			}
			let url = note.ref;
			let accessDate = moment().format('Do MMMM YYYY');
			let accessYear = moment().format('YYYY');
			return `${accessYear}. ${title}. [online] Available at: <${url}> [Accessed ${accessDate}]`;
		}
	},
	{
		name: 'APA - In text citation',
		description:
			'APA style annotation. Good for pasting directly into the research paper',
		category: 'Citation styles',
		fx: function(note) {
			let title = '';
			if (note.meta && note.meta.title) {
				title = note.meta.title;
			}
			let url = note.ref;
			let accessDate = moment().format('Do MMMM YYYY');
			let accessYear = moment().format('YYYY');
			return `(${title}, ${accessYear})`;
		}
	},
	{
		name: 'MLA(8th Edition) - Biblography',
		description: 'MLA style, good for pasting as a reference',
		category: 'Citation styles',
		fx: function(note) {
			let title = '';
			if (note.meta && note.meta.title) {
				title = note.meta.title;
			}
			let url = note.ref;
			let accessDate = moment().format('Do MMMM YYYY');
			let accessYear = moment().format('YYYY');
			return `${title}. ${accessYear}, ${url}. Accessed ${accessYear}.`;
		}
	}
];

var store = {
	namespaced: true,
	state: {
		currentSelection: null,
		options: options
	},
	getters: {
		options: function(state) {
			return state.options;
		},
		currentSelection: function(state) {
			return state.currentSelection;
		}
	},
	mutations: {
		SET_CURRENTSELECTION: function(state, name) {
			state.currentSelection = name;
		}
	},
	actions: {
		async getCopy(store, note) {
			let style = store.state.currentSelection || '';
			style = options.filter(s => {
				if (s.name === style) {
					return true;
				} else {
					return false;
				}
			});
			if (style.length > 0) {
				style = style[0];
				console.log(style);
				return style.fx(note);
			} else {
				return '';
			}
		},
		async setCurrentSelection(store, name) {
			store.commit('SET_CURRENTSELECTION', name);
		}
	}
};

export default store;
